import {
  Card,
  CardBody,
  CircularProgress,
  Spinner,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from '@nextui-org/react'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from 'src/lib/api'
import countryObject from 'src/data/country_object.json'

export default function TendersReport() {
  const params = useParams()
  const [tenders, setTenders] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const loadMyTenders = async () => {
    const res = await api.get(`/tenders/reports/${params.userUUID}`)
    setTenders(res.data?.data ?? [])
    setLoading(false)
  }
  useEffect(() => {
    if (params.userUUID) loadMyTenders()
  }, [params])
  const formatValue = (tender: any) => {
    try {
      if (!tender.totalValue) return '-'
      return Intl.NumberFormat('de-DE', {
        currency: tender.valueCurrency,
        style: 'currency',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(tender.totalValue)
    } catch (err) {
      return `${Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(tender.valueCurrency)} ${tender.valueCurrency}`
    }
  }
  return (
    <div className="flex flex-1">
      {loading && (
        <div className="flex justify-center items-center flex-1">
          <Card>
            <CardBody className="flex flex-row items-center p-4 px-12 min-w-[260px] min-h-[250px] gap-4">
              <Spinner size="md" />
              <h2 className="text-bold text-md">Loading your report</h2>
            </CardBody>
          </Card>
        </div>
      )}
      <div className="flex flex-1 items-center flex-col pt-8">
        <img src={'/img/powerdocs-logo-signet.png'} alt={'logo'} className={'h-[100px] mb-3'} />
        <h1 className={'text-4xl font-medium'}>Your Reports</h1>
        <h2 className={'text-md font-light text-default-400'}>List of tenders that matches your profile.</h2>
        <div className="w-3/4 p-8">
          <Table
            classNames={{
              wrapper: 'p-0 shadow-none',
            }}
            aria-label="Table of public tenders"
          >
            <TableHeader>
              <TableColumn>Project description</TableColumn>
              <TableColumn>Score</TableColumn>
              <TableColumn>Value</TableColumn>
              <TableColumn>Country</TableColumn>
              <TableColumn>Due date</TableColumn>
              <TableColumn> </TableColumn>
            </TableHeader>
            <TableBody>
              {tenders.map((assignedTender) => (
                <TableRow key={assignedTender.uuid}>
                  <TableCell className="max-w-[350px]">
                    <div className="flex flex-row">
                      <div
                        className="flex flex-col"
                        onClick={() => {
                          if (assignedTender?.tender?.url) {
                            window.open(assignedTender?.tender?.url)
                          }
                        }}
                      >
                        <span className="text-black text-xs font-bold cursor-pointer hover:underline">
                          {assignedTender?.tender?.title}
                        </span>
                        <span className="text-default-400 text-xs font-medium">
                          Buyer {assignedTender?.tender?.buyer}
                        </span>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>
                    <CircularProgress
                      color={
                        assignedTender?.score >= 70 ? 'secondary' : assignedTender?.score >= 40 ? 'warning' : 'success'
                      }
                      showValueLabel={true}
                      size="lg"
                      value={assignedTender?.score ?? 50}
                    />
                  </TableCell>
                  <TableCell className="text-right">{formatValue(assignedTender?.tender)}</TableCell>
                  <TableCell>
                    {countryObject?.[assignedTender?.tender?.country?.toUpperCase()] ||
                      assignedTender?.tender?.country ||
                      'N/A'}
                  </TableCell>
                  <TableCell>
                    {assignedTender?.tender?.deadline
                      ? dayjs(assignedTender?.tender?.deadline).format('YYYY-MM-DD')
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    <a
                      onClick={() => window.open(assignedTender?.tender?.url)}
                      className="text-xs font-bold cursor-pointer"
                    >
                      Open Tender
                    </a>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  )
}
